import * as Types from '../State/types';

export const routeForCollection = (id: Types.StringModelId) => {
  return `/collections/${id}`;
};

export const mainView = () => {
  return '/';
};
